import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert } from 'react-bootstrap';
import defaultMsg from '../../../translations/lang/en-US.json';

export default class ApiError extends React.Component {
	render() {
		return (
			<Alert bsStyle="danger" className="font-small">
				<strong>
					<FormattedMessage
						id="pleaseFixErrors"
						defaultMessage={defaultMsg.pleaseFixErrors}
					/>
				</strong>
				<hr style={{ margin: '4px 0px' }} />
				<ul style={{ paddingLeft: '14px' }}>
					{this.props.errors.map((errorMessage, errorKey) => {
						return errorMessage ? (
							<li key={errorKey}>{errorMessage}</li>
						) : null;
					})}
				</ul>
			</Alert>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/auth/passwordreset/ApiError.jsx